/**
 * FounderGuard — redirects non-founder users to / silently.
 *
 * Unlike AdminGuard, this guard ONLY passes users whose authenticated
 * email is on the founder allow-list (useIsFounder, email-only check).
 * It deliberately ignores localStorage flags and build-env shortcuts.
 *
 * Applied to all /omega/* routes — OMEGA is the Founder's absolute secret.
 */
import { Navigate } from 'react-router-dom';
import { useIsFounder } from '@/hooks/useIsAdmin';

export function FounderGuard({ children }: { children: React.ReactNode }) {
  const founder = useIsFounder();
  if (!founder) return <Navigate to="/" replace />;
  return <>{children}</>;
}
